/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Annual_PeriodInputs */

const en_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annual`)
};

const id_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahunan`)
};

const ms_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahunan`)
};

const ca_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual`)
};

const cs_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roční`)
};

const da_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årligt`)
};

const de_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährlich`)
};

const et_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aastane`)
};

const es_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual`)
};

const fr_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuel`)
};

const hr_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godišnja`)
};

const it_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuale`)
};

const lv_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gada maksājums`)
};

const lt_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metinis`)
};

const hu_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éves`)
};

const nl_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaarlijks`)
};

const nb_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årlig`)
};

const pl_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roczna`)
};

const pt_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual`)
};

const ro_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual`)
};

const sk_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ročne`)
};

const sl_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letno`)
};

const fi_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuosittainen`)
};

const sv_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årlig`)
};

const vi_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hằng năm`)
};

const tr_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yıllık`)
};

const el_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ετησίως`)
};

const bg_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Годишно`)
};

const ru_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежегодно`)
};

const sr_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Годишње`)
};

const uk_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Річна`)
};

const ka_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`წლიური`)
};

const hi_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एनुअल`)
};

const th_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายปี`)
};

const ko_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연`)
};

const zh_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年度`)
};

const zh_tw_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年度`)
};

const ja_annual_period = /** @type {(inputs: Annual_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年間プラン`)
};

/**
* | output |
* | --- |
* | "Annual" |
*
* @param {Annual_PeriodInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const annual_period = /** @type {((inputs?: Annual_PeriodInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Annual_PeriodInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_annual_period(inputs)
	if (locale === "ms") return ms_annual_period(inputs)
	if (locale === "ca") return ca_annual_period(inputs)
	if (locale === "cs") return cs_annual_period(inputs)
	if (locale === "da") return da_annual_period(inputs)
	if (locale === "de") return de_annual_period(inputs)
	if (locale === "et") return et_annual_period(inputs)
	if (locale === "es") return es_annual_period(inputs)
	if (locale === "fr") return fr_annual_period(inputs)
	if (locale === "hr") return hr_annual_period(inputs)
	if (locale === "it") return it_annual_period(inputs)
	if (locale === "lv") return lv_annual_period(inputs)
	if (locale === "lt") return lt_annual_period(inputs)
	if (locale === "hu") return hu_annual_period(inputs)
	if (locale === "nl") return nl_annual_period(inputs)
	if (locale === "nb") return nb_annual_period(inputs)
	if (locale === "pl") return pl_annual_period(inputs)
	if (locale === "pt") return pt_annual_period(inputs)
	if (locale === "ro") return ro_annual_period(inputs)
	if (locale === "sk") return sk_annual_period(inputs)
	if (locale === "sl") return sl_annual_period(inputs)
	if (locale === "fi") return fi_annual_period(inputs)
	if (locale === "sv") return sv_annual_period(inputs)
	if (locale === "vi") return vi_annual_period(inputs)
	if (locale === "tr") return tr_annual_period(inputs)
	if (locale === "el") return el_annual_period(inputs)
	if (locale === "bg") return bg_annual_period(inputs)
	if (locale === "ru") return ru_annual_period(inputs)
	if (locale === "sr") return sr_annual_period(inputs)
	if (locale === "uk") return uk_annual_period(inputs)
	if (locale === "ka") return ka_annual_period(inputs)
	if (locale === "hi") return hi_annual_period(inputs)
	if (locale === "th") return th_annual_period(inputs)
	if (locale === "ko") return ko_annual_period(inputs)
	if (locale === "zh") return zh_annual_period(inputs)
	if (locale === "zh-tw") return zh_tw_annual_period(inputs)
	if (locale === "ja") return ja_annual_period(inputs)
	return en_annual_period(inputs)
});